import React from "react";
import { cn } from "../../../../lib/utils";
import { FORMAT_OPTIONS } from "../../../../config/workoutOptions";
import { autoFormatFor, hasSelector } from "../../../../utils/sessionFormat";

const FormatDetail = ({ config, onChange }) => {
  if (hasSelector(config.workoutTypes)) {
    const who = (config.workoutTypes || []).includes("next")
      ? "What's next"
      : "Surprise me";
    return (
      <p className="text-sm leading-relaxed text-muted-foreground">
        {who} picks the format along with the session. Pick goals under Train
        for to choose the format yourself.
      </p>
    );
  }
  const current = config.format || "auto";
  const auto = autoFormatFor({ goals: config.workoutTypes, noFaff: config.noFaff });
  const autoLabel = auto && FORMAT_OPTIONS.find((o) => o.value === auto)?.label;

  return (
    <div role="radiogroup" aria-label="Format" className="space-y-1.5">
      {FORMAT_OPTIONS.map((o) => {
        const on = current === o.value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={on}
            onClick={() => onChange(o.value)}
            className={cn(
              "grid w-full grid-cols-[1.25rem_minmax(0,1fr)] gap-2.5 rounded-xl border px-3 py-2.5 text-left transition-colors",
              on ? "border-primary/50 bg-primary/10" : "border-border bg-background/40 hover:border-primary/30",
            )}
          >
            <span
              className={cn(
                "mt-0.5 h-[18px] w-[18px] rounded-full border-2",
                on ? "border-primary bg-primary shadow-[inset_0_0_0_3px_hsl(var(--card))]" : "border-muted-foreground",
              )}
            />
            <span className="min-w-0">
              <span className="block text-sm font-semibold text-foreground">
                {o.label}
                {o.value === "auto" && autoLabel && (
                  <span className="font-normal text-muted-foreground">
                    {" "}
                    ({autoLabel} today, because No faff is on)
                  </span>
                )}
              </span>
              <span className="mt-0.5 block text-xs leading-snug text-muted-foreground">
                {o.description}
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default FormatDetail;
